import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Los hostings compartidos suelen bloquear PUT/PATCH/DELETE con mod_security
// y devuelven 403 antes de que la peticion llegue a PHP. Se mandan como POST
// declarando el metodo real; el backend lo traduce en public/index.php.
// Se envia por cabecera y tambien por querystring, porque algunos servidores
// filtran las cabeceras no estandar.
const OVERRIDE_METHODS = ['put', 'patch', 'delete'];

// Request interceptor - attach token + anti-cache + method override
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const method = (config.method || 'get').toLowerCase();

  if (OVERRIDE_METHODS.includes(method)) {
    config.headers['X-HTTP-Method-Override'] = method.toUpperCase();
    config.params = { ...(config.params || {}), _method: method.toUpperCase() };
    config.method = 'post';
  }

  // Prevent browser/proxy cache on GETs (cPanel/shared hosts can cache aggressively)
  if (method === 'get') {
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    config.params = { ...(config.params || {}), _t: Date.now() };
  }
  return config;
});

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !error.config._retry) {
      error.config._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const res = await axios.post('/api/auth/refresh', {}, {
            headers: { Authorization: `Bearer ${refreshToken}` }
          });
          const newToken = res.data.access_token;
          if (newToken) {
            localStorage.setItem('access_token', newToken);
            // El backend rota el refresh en cada renovacion: hay que guardarlo
            // o la sesion seguiria caducando a las N horas del login original.
            if (res.data.refresh_token) {
              localStorage.setItem('refresh_token', res.data.refresh_token);
            }
            error.config.headers.Authorization = `Bearer ${newToken}`;
            return api.request(error.config);
          }
        } catch (refreshError) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper function to format API error
export function formatApiError(error) {
  const detail = error.response?.data?.detail;
  if (detail == null) return 'Algo salió mal. Por favor intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
